import React from 'react';

const IconMedium = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    role="img"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.5"
    strokeLinecap="round"
    strokeLinejoin="round">
    <title>Medium</title>
    <circle cx="7" cy="12" r="5" />
    <ellipse cx="17.5" cy="12" rx="2.5" ry="5" />
    <line x1="22" y1="7" x2="22" y2="17" />
  </svg>
);

export default IconMedium;
